import * as React from 'react'
import { ReactComponent as Logo } from '../../assets/logo.svg'
import { doLogOut } from '../../common/auth/authActions'
import { IRoute, ROUTES } from '../../common/Routes/routePaths'
import { currentLangString } from '../../i18nInit'
import { store } from '../../index'
//import { LanguageSelection } from '../LanguageSelection/LanguageSelection'
import { YNavLink } from '../YNavLink/YNavLink'
import './Navbar.scss'
import { NavProfile } from './NavProfile/NavProfile'
import { redirectUrl } from '../../common/helpers/routeHelpers'
import { isNative } from '../../common/helpers/isNative'
import { websiteUrl } from '../../services/apiUrl'
import { Link } from 'react-router-dom'
import { ReactComponent as ArrowBackIcon } from '../../assets/v2/icons/icon-header-back-btn.svg'
import { Button } from '../../components/Button/Button'
import { ReactComponent as SyncIcon } from '../../assets/icons/sync.svg'
//import { ReactComponent as SyncIcon } from '../../assets/icons/sync-new.svg'
import { OnboardingStatus, ServiceProvider } from '../../services/api.types'
import { YumLanguageSelection } from '../YumLanguageSelection/YumLanguageSelection'
import YumChallengeTitleWrapper from '../YumChallengeTitle/YumChallengeTitleWrapper'
import { Capacitor } from '@capacitor/core'
import { INotification } from '../../common/notifications/NotificationReducers'
import { t } from 'ttag'
import { addNotification } from '../../common/notifications/NotificationActions'
import { scrollToTop } from '../../common/helpers/scroll'
import { dataSync, refreshActivityView } from '../../services/DataSync'
import { getUserCompanies } from '../../common/auth/authSelectors'
import { IGlobalState } from '../../Root/store/appReducer'

interface INavbarProps {
  routes: IRoute[]
  authenticated: boolean
  fullName?: string
  companyName?: string
  isLanguageSelectionVisible: boolean
  currentRoute: Partial<Location>
  isAdmin: boolean
  onboardingStatus: OnboardingStatus
  brandLogoUrl: string
  serviceProvider: string
  newUserAdmin: boolean
}

interface INavbarState {
  isProfileOpen: boolean
}

export class Navbar extends React.Component<INavbarProps, INavbarState> {
  state = { isProfileOpen: false }

  toggleDropdown = () => this.setState(({ isProfileOpen }) => ({ isProfileOpen: !isProfileOpen }))
  hideDropdown = () => this.setState({ isProfileOpen: false })

  handleLogout = () => {
    this.toggleDropdown()
    store.dispatch(doLogOut())
  }

  syncData = async () => {
    // const { syncIntegration, getWhoAmI, userDto } = this.props
    const { serviceProvider } = this.props
    const os = Capacitor.getPlatform()
    const appSync =
      (os === 'ios' && serviceProvider === ServiceProvider.APPLE_HEALTH) ||
      (os === 'android' && serviceProvider === ServiceProvider.GOOGLE_FIT)

    /*if (serviceProvider === ServiceProvider.APPLE_HEALTH && os !== 'ios') {
      const notification: INotification = {
        type: 'info',
        content: t`Download YuMuuv from the App Store. Log in with your email and password.`,
      }
      await store.dispatch(addNotification(notification))
      return
    }*/

    // Notify back-end and show message.
    // syncIntegration({ noMessage: false })

    // So people see the message.
    // scrollToTop()

    // If it's Apple Health or Google Fit, initiate sync from front-end.
    if (appSync) {
      await dataSync(true, true)
    }
    // Otherwise show syncing icon for 10 seconds.
    else {
      /*document.body.classList.add('is-syncing')
      getWhoAmI()
      setTimeout(() => {
        refreshActivityView()
        document.body.classList.remove('is-syncing')
      }, 30000)*/
    }
  }

  render() {
    const {
      routes,
      authenticated,
      fullName,
      isLanguageSelectionVisible,
      currentRoute,
      isAdmin,
      onboardingStatus,
      brandLogoUrl,
      serviceProvider,
      newUserAdmin,
    } = this.props
    const { isProfileOpen } = this.state

    const profileRoutes = isAdmin
      ? [newUserAdmin ? { ...ROUTES.ADMIN_USER_NEW } : { ...ROUTES.ADMIN_USER }, { ...ROUTES.SETTINGS }]
      : onboardingStatus === OnboardingStatus.DONE
      ? [{ ...ROUTES.SETTINGS }]
      : []

    const loggedInNav = (
      <NavProfile
        fullName={fullName || ''}
        isProfileOpen={isProfileOpen}
        routes={profileRoutes}
        toggleProfileDropdown={this.toggleDropdown}
        onLogout={this.handleLogout}
      />
    )
    const logoHref = currentRoute.pathname === ROUTES.REGISTER_USER.to ? ROUTES.REGISTER_USER.to : redirectUrl()

    const pathParts = currentRoute.pathname ? currentRoute.pathname.split('/') : []
    const isChallengePage = !!(pathParts[1] === 'challenges' && pathParts[3] && pathParts[3] != 'edit')
    const goalId = isChallengePage ? pathParts[2] : undefined
    //const isChatPage = pathParts[3] === 'chat'
    //const backLink = isChatPage ? `${ROUTES.CLIENT_ACTIVITY.to}/${pathParts[2]}` : logoHref
    const backLink = logoHref

    const websiteLocale = ['en', 'et'].includes(currentLangString) ? currentLangString : 'en'
    const websiteHref = `${websiteUrl}/${websiteLocale}`

    return (
      <div className="nav">
        <div className="nav__routes">
          {(store.getState() as any).auth.authenticated || isNative() ? (
            <div className={'nav__logo-wrapper'}>
              <Link className="nav__logo-btn" to={backLink}>
                <ArrowBackIcon />
              </Link>
              <div className={isChallengePage ? 'show-on-desktop' : ''}>
                <YNavLink to={logoHref} className="nav__logo" onClick={this.hideDropdown}>
                  {brandLogoUrl ? (
                    <img src={brandLogoUrl} alt="Brand logo" style={{ height: '40px', width: 'auto' }} />
                  ) : (
                    <Logo />
                  )}
                </YNavLink>
              </div>
            </div>
          ) : (
            <>
              <a className={isChallengePage ? 'show-on-desktop' : ''} href={websiteHref}>
                {brandLogoUrl ? (
                  <img src={brandLogoUrl} alt="Brand logo" style={{ height: '40px', width: 'auto' }} />
                ) : (
                  <Logo />
                )}
              </a>
            </>
          )}
          {routes.length > 0 && (
            <div className="nav__links">
              {routes.map(({ to, title, component, shortTitle, icon: Icon }, index) => (
                <YNavLink className="nav__item" key={`nav-item-${index}`} to={to} onClick={this.hideDropdown}>
                  {Icon && <Icon className="nav__icon" />}
                  <span className="nav__label" data-title={title}>
                    {title}
                  </span>
                  <span className="nav__label-short">{shortTitle || title}</span>
                </YNavLink>
              ))}
            </div>
          )}
        </div>

        {isChallengePage && <YumChallengeTitleWrapper className={'hide-on-desktop'} goalId={goalId} />}

        {isLanguageSelectionVisible && (
          <div style={{ marginTop: '5px' }}>
            <YumLanguageSelection display={{ xs: 'none', md: 'block' }} />
          </div>
        )}
        {/*{isLanguageSelectionVisible && <LanguageSelection currentLang={getLocale()} isWhite={true} />}*/}
        {authenticated && (
          <div className="nav__profile">
            <Button
              /*onClick={this.syncData}*/
              className={'btn-sync ' /*+ (isNative() ? 'visible' : '')*/}
              link={true}
              iconLeft={SyncIcon}
            />
            {loggedInNav}
          </div>
        )}
      </div>
    )
  }
}
